module.exports = __webpack_public_path__ + "media/images/lb/052-561f46f2b16dd79c4045f848f1209f50.svg";